import BarChartOutlined from "@mui/icons-material/BarChartOutlined";
import Update_Icon from "../images/table/Update_icon.svg";
import Track_Icon from "../images/table/View_icon.svg";
import Delete_Icon from "../images/table/Delete_icon.svg";
import Schedule_Icon from "../images/table/Schedule_icon.svg";

export const FLEET_ROUTE_ROW_ACTIONS = {
  analyticsRoute: {
    id: "analytics",
    label: "Analytics",
    icon: BarChartOutlined,
    path: "",
  },
  updateRoute: {
    id: "update",
    label: "Update",
    icon: Update_Icon,
    path: "/route/add",
    permission: { apiPath: "/api/route", action: "PUT" },
  },
  monitorRoute: {
    id: "monitor",
    label: "Monitor",
    icon: Track_Icon,
    path: "/route/track",
    permission: { apiPath: "/api/route/id", action: "GET" },
  },
  scheduleRoute: {
    id: "schedule",
    label: "Schedule",
    icon: Schedule_Icon,
    path: "/route/schedules",
    permission: { apiPath: "/api/route/schedules", action: "GET" },
  },
  deleteRoute: {
    id: "delete",
    label: "Delete",
    className: "delete",
    icon: Delete_Icon,
    path: "",
    permission: { apiPath: "/api/route", action: "DELETE" },
  },
};

export const ROUTE_TABLE_COLUMN_CATALOG = {
  routeId: { key: "routeCode", width: "110px" },
  routeName: { key: "routeName", width: "180px", cell: "routeName" },
  stops: { key: "stopCount", width: "80px" },
  distance: { key: "distanceLabel", width: "100px" },
  duration: { key: "durationLabel", width: "120px" },
  status: { key: "status", width: "120px", cell: "status" },
  adherence: { key: "adherenceLabel", width: "140px" },
  lastUpdate: { key: "lastUpdate", width: "130px", cell: "lastUpdate" },
  vehicles: { key: "vehicles", width: "180px" },
  pickUp: { key: "pickUp", width: "160px" },
  drop: { key: "drop", width: "160px" },
};

export const ROUTE_DASHBOARD_STAT_METRIC_KEYS = [
  "activeRoutes",
  "tripsStarted",
  "delayedTrips",
  "avgDelay",
  "adherence",
  "totalRuntime",
];

export const ROUTE_STAT_TONE_BY_VARIANT = {
  darkBlue: "blue",
  green: "green",
  yellow: "amber",
  red: "red",
};

export function computeFleetRouteMetric(metricKey, routeData = []) {
  const routes = Array.isArray(routeData) ? routeData : [];

  switch (metricKey) {
    case "totalRoutes":
    case "activeRoutes":
      return routes.length;
    case "connectedStops":
      return routes.reduce((total, route) => {
        if (!Array.isArray(route.stops)) {
          return total;
        }
        return total + route.stops.length;
      }, 0);
    default:
      return 0;
  }
}
